const ioCache = new Map()

const bindObserverHandler = (el, binding) => {
  const config = binding.value.config || {
    threshold: [0, 0.5, 1]
  }
  const handler = binding.value.handler || function () {}
  const io = new IntersectionObserver((enteries, observer) => {
    enteries.forEach(entry => {
      handler(entry, observer, el)
    })
  }, config)
  io.observe(el)
  return io
}

const directive = {
  inserted (el, binding) {
    const io = bindObserverHandler(el, binding)
    // 缓存当前el节点，在update中更新使用
    if (!ioCache.has(el)) {
      ioCache.set(el, io)
    }
  },
  componentUpdated (el, binding) {
    const tempIo = ioCache.get(el)
    if (tempIo) {
      ioCache.delete(el)
      tempIo.disconnect()
    }
    const io = bindObserverHandler(el, binding)
    ioCache.set(el, io)
  },
  unbind (el) {
    // observer.disconnect()
    const io = ioCache.get(el)
    io.disconnect()
    ioCache.delete(el)
  }
}

const pluginName = 'scrollInView'
var scrollInView = {
  install (Vue, _options) {
    // todo 全局配置一些intersection的配置
    // console.log(options)
    Vue.directive(pluginName, directive)
  }
}

export default scrollInView
